import { Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import { useDispatch } from 'react-redux';
import { viewImage } from '../../CommonUtils/viewImage';
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import { BsFiletypePdf } from 'react-icons/bs';

export default function Affl_OrderGen2022Govt() {
    let navigated = useNavigate();
    const dispatch = useDispatch();
    const handleNavigatefun = (collCode, type) => {
        navigated("/AfflOrderGenGovtDetails", { state: { type: type } });
        dispatch({ type: "COLLEGE_CODE", payload: collCode });
    };
    const afflOrderGenFormik = useFormik({
        enableReinitialize: true,
        initialValues: {},
        validationSchema: "",
        onSubmit: (values) => {
        }
    })
    const [AfflorderData23, setAfflorderData23] = useState([]);
    function AfflOrdrerGovt() {
        let url = config.url.API_URL + `govtAfflOrderReport`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setAfflorderData23(res?.data?.govtAfflOrderReport)
            } else {
                setAfflorderData23([])

            }
        })
    }
    useEffect(() => {
        AfflOrdrerGovt();
    }, [])

    const CourseDataReportColumns23 = [
        { Header: "Sl.no", accessor: (row, index) => index + 1, },
        { Header: "College Code", accessor: "coll_code", },
        {
            Header: "College Name", accessor: "coll_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.coll_name}</div>
            ),
        },

        {
            Header: "Nature Of the College", accessor: "coll_nature_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.coll_nature_name}</div>
            ),
        },
        {
            Header: "Affiliation Order", accessor: "final_pdf_path",
            Cell: ({ row }) => {
                const value = row?.values?.final_pdf_path;
                // return <button type="button" className="btn btn  btn-md pt-1" style={{ color: "blue", textDecoration: "underline" }} onClick={() => { handleNavigatefun(row?.original?.coll_code, "Govt") }}>Click Here to get Affiliation Order </button>
                if (value === "Click Here to generate Affiliation Order") {
                    return <button type='button' className='btn rounded-pill btn-sm btn-primary' onClick={() => { handleNavigatefun(row?.original?.coll_code, "GOVT") }}>  Click Here to get Affiliation Order</button>;
                } else {
                    return (
                        <button type="button" className="btn btn  btn-md pt-1"
                            onClick={() => {
                                viewImage(value);

                            }}>
                            <BsFiletypePdf color="red"
                                size={20} />
                        </button>
                    );
                }
            }
        }
    ]
    return (
        <>
            <CommonFormHeading heading="Govt  Approve and Generate Affiliation Order" />
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <FormikProvider value={afflOrderGenFormik}>
                    <Form onChange={afflOrderGenFormik?.handleChange} onSubmit={afflOrderGenFormik?.handleSubmit} className="form_adjust" >
                        <bie.Row className="px-2 pt-3 mb-3 pb-3">
                            {AfflorderData23?.length > 0 ? (
                                <div className="table-responsive">
                                    <CommonReactTable data={AfflorderData23} columns={CourseDataReportColumns23} pagination="false" filename="Govt Approve and Generate Affiliation Order" headerName={`Govt Approve and Generate Affiliation Order`} />
                                </div>
                            ) : <center className='text-danger h5 pt-5'>*** No Data Found ***</center>}
                        </bie.Row>
                    </Form>
                </FormikProvider>
            </bie.Container>

        </>)

}
